<template>
  <div class="btnBox">
    <el-button type="text" class="backBtn" @click="back">
      <i class="el-icon-arrow-left" />
      返回
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'backBtn',
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.backBtn {
  color: #1989fa;
  font-size: 16px;
}
.btnBox {
  text-align: left;
}
</style>
